<template>
    <div>
        <BCard v-if="cash">
            <BRow>
                <BCol cols="12" xl="6">
                    <table class="mt-2 mt-xl-0 w-100">
                        <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="cash.name" />
                    </table>
                </BCol>
                <BCol cols="12" xl="6">
                    <table class="mt-2 mt-xl-0 w-100">
                        <ViewData vsIcon="HomeIcon" vsLabel="Group" :vsValue="cash.group ? cash.group.name : '' " />
                    </table>
                </BCol>
                <BCol cols="12" class="pt-3">
                    <div class="d-flex flex-wrap">
                        <BButton :to="{ name: 'cash-edit', params: { id: cash.id } }" variant="primary" v-if="ability.can('write', 'cash')"> {{$t('Edit')}} </BButton>
                        <BButton variant="outline-danger" class="ml-1" @click="deletePopup(cash.id, 'cashes/deleteCash', 'cash')" v-if="ability.can('delete', 'cash')"> {{$t('Delete')}} </BButton>
                    </div>
                </BCol>
            </BRow>
        </BCard>
        <BCard v-if="cash" no-body>
            <BCardBody class="pb-0 mb-0">

                <BRow>
                    <BCol cols="12">
                            <BCardTitle>Movimientos</BCardTitle>
                            <BCardSubTitle>Listado de los movimientos realizados en caja</BCardSubTitle>
                    </BCol>
                </BRow>
                
            </BCardBody>
            <CashViewMovements ref="movementsTable" :key="key"/>
        </BCard>

    </div>
</template>
<script>
import { BButton, BCard, BCardBody, BCardSubTitle, BCardTitle, BCol, BRow, BFormInput, BDropdown, BDropdownItem } from 'bootstrap-vue'
import { provide, ref, onUnmounted } from '@vue/composition-api'
import CashViewMovements from './CashViewMovements.vue'
import ViewData from '@/components/ViewData.vue'
import ability from '@/libs/acl/ability'
import popups from '@/hooks/popups'
import router from '@/router'
import axios from '@axios'
import cashModule from '../cashModule';
import store from '@/store';
import cashMovementsListQuery from '../../cash-movements/cash-movements-list/cashMovementsListQuery';
import vSelect from 'vue-select'


export default {
    components: { ViewData, BButton, BCard, BRow, BCol, CashViewMovements, BCardBody, BCardTitle, BCardSubTitle, BFormInput, BDropdown, BDropdownItem, vSelect },
    setup() {
        const CASH_MODULE = 'cashes'
        const { deletePopup, successToast, errorToast } = popups()
        const {  perPage, perPageOptions, movementsTable, key} = cashMovementsListQuery()
        const cash = ref(null)


        //& Consultas
        axios.get(`cashes/${router.currentRoute.params.id}`).then(response => {
            cash.value = response.data.cash
        })

        provide('cash', cash)
        
        if(!store.hasModule(CASH_MODULE)){
            store.registerModule(CASH_MODULE, cashModule)
        }

        onUnmounted(() => {
            if(store.hasModule(CASH_MODULE)) {
                store.unregisterModule(CASH_MODULE)
            }
        })



        return {
            deletePopup,
            ability,
            cash,
            perPageOptions,
            perPage,
            movementsTable,
            key
        }
    },
}


</script>
